export default __webpack_public_path__ + "static/media/pic (6).2b09520d.jpg";